import { debounce } from "lodash";
import { useState, useEffect } from "react";
function useWindowSize() {
    var ref = useState({
        width: undefined,
        height: undefined
    }), windowSize = ref[0], setWindowSize = ref[1];
    useEffect(function() {
        var isUnmounted = false;
        var handleResize = debounce(function() {
            if (isUnmounted) {
                return;
            }
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }, 50);
        window.addEventListener("resize", handleResize);
        handleResize();
        return function() {
            isUnmounted = true;
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return windowSize;
}
export default useWindowSize;
